import $ from 'jquery';
import {is_function} from '../../../Helpers/js';


export const Confirmation = (function () {
    return {
        confirm: function (type, title, text, onYes, onNo) {
            var $dialog = $('.ui.modal[data-confirm-type="' + type + '"]');
            if ($dialog.length > 0) {
                Confirmation._show($dialog, type, title, text, onYes, onNo);
            } else { // load confirm dialog from server, if not loaded yet
                Confirmation.load(type, function (json) {
                    var $dialog = $(json.html);
                    $('body').append($dialog);
                    $dialog.attr('data-confirm-type', type);
                    Confirmation._show($dialog, type, title, text, onYes, onNo);
                });
            }
        },

        _show: function ($dialog, type, title, text, onYes, onNo) {
            $dialog.find('[data-content="confirm-title"]').html(title);
            $dialog.find('[data-content="confirm-text"]').html(text);
            $('.ok.button', $dialog).removeClass('loading');

            $dialog
                .modal({
                    blurring: true,
                    duration: 100,
                    observeChanges: true,
                    allowMultiple: true,
                    onApprove: function () {
                        $('.ok.button', $dialog).addClass('loading');
                        if (is_function(onYes) && onYes() || !is_function(onYes)) {
                            $dialog.modal('hide').remove();

                        }
                    },
                    onDeny: function () {
                        if (is_function(onNo) && onNo() || !is_function(onNo)) {
                            $dialog.modal('hide').remove();
                        }
                    },
                    onHide: function () {

                    }
                })
                .modal('show');
        },

        load: function (type, onSuccess, onError) {
            window.Browser.send(
                '/ui/confirmations/' + type,
                null,
                onSuccess,
                onError
            );
        }
    };
})();